import React from 'react';
import { TBody, Th, THead, Tr } from '../../../shared/Table';
import { DataForDesignDrawingsManifold } from '../../designs/data-for-design-drawings/dataForDesignDrawingsResponse';
import { CoilDiameterRow } from '../../shared/manifold-table/CoilDiameterRow';
import { CoilLengthRow } from '../../shared/manifold-table/CoilLengthRow';
import { CoilQuantityRow } from '../../shared/manifold-table/CoilQuantityRow';
import { CutLengthRow } from '../../shared/manifold-table/CutLengthRow';
import { FloorSensorRow } from '../../shared/manifold-table/FloorSensorRow';
import { MinimumFlowRateRow } from '../../shared/manifold-table/MinimumFlowRateRow';
import { PortsRow, PortsRowWidths } from '../../shared/manifold-table/PortsRow';
import { RemoteAirSensorRow } from '../../shared/manifold-table/RemoteAirSensorRow';
import { RoomNameRow } from '../../shared/manifold-table/RoomNameRow';
import { ThermostatRow } from '../../shared/manifold-table/ThermostatRow';
import { ManifoldDiagramTable } from './ManifoldDiagramWithTable';

type Props = {
  manifold: DataForDesignDrawingsManifold;
  portsRowWidths: PortsRowWidths;
  numberOfPorts: number;
  className?: string;
};

export const ManifoldDiagramTopTable = ({ manifold, portsRowWidths, numberOfPorts, className }: Props) => {
  return (
    <ManifoldDiagramTable className={className}>
      <THead>
        <Tr>
          <Th colSpan={numberOfPorts + 1}>
            {manifold.name} ({manifold.flowTemperatureInDegreesCelsius}&deg;C flow temperature)
          </Th>
        </Tr>
        <PortsRow numberOfPorts={numberOfPorts} portsRowWidths={portsRowWidths} />
      </THead>
      <TBody>
        <RoomNameRow manifold={manifold} />
        <ThermostatRow manifold={manifold} />
        <FloorSensorRow manifold={manifold} />
        <RemoteAirSensorRow manifold={manifold} />
        <CoilQuantityRow manifold={manifold} />
        <CoilDiameterRow manifold={manifold} />
        <CoilLengthRow manifold={manifold} />
        <CutLengthRow manifold={manifold} roundUp={true} />
        <MinimumFlowRateRow manifold={manifold} precision={1} roundingMethod="Ceiling" />
      </TBody>
    </ManifoldDiagramTable>
  );
};
